export interface findAllCustomersResponseDTO {
    data: CustomerResponseDTO[],
    next: boolean,
    page: number,
    perPage: number,
    prev: false,
    total: number,
    totalPage: number
}

export interface CustomerResponseDTO {
    legalForm?: string
    companyName: string
    cuaa: string
    vat: string
    address: string
    countryRegion: string
    province: string
    city: string
    zipCode?: number
    rpAddress: string
    rpCountryRegion: string
    rpCity: string
    rpProvince: string
    rpZipCode?: number
    adresseeCode?: string
    accountingCode?: string,
    bankDetails?: string,
    startingDate: Date,
    endingDate: Date,
    entryReason: string,
    exitReason?: string
    norm: string
    active: boolean
    userId: string
    id: string
    headQuarterIds: string
    headQuartersInfo: headQuarterInfoDTO[]
    clientType: string
    operatorsGroup: string
    zrType?: string
    zrCertificationType?: string
    zrAddingRequirements?: string
    zrTargetThreshold?: Number
    sqnpiAdhesionType: string[]
    sqnpiSubjectType?: string
    sqProductionChain: string[]
    biologicalActivity: BiologicalActivityDTO[]
    clientCode: string
    ggGgn?: string
    ggStandard?: string
    ggEdition?: string
    ggApplicationField?: string
    ggCategory?: string
    ggIFACertificationOption?: string
    ggManipulation?: string
    ggParallelProperty?: boolean
    ggLabelling?: boolean
    ggLicenseGnnLabelLogo?: boolean
    ggPartialTransformation?: boolean
    ggCOCCertificationOption?: string
    ggAddOns: ggAddonsDTO[]
    ggAddOnsId: string[]
    entryOdcId?: string
    exitOdcId?: string
    companyCenterIds: string[]
    legalRepresentativeIds: string[]
    contactId: string
}

export interface headQuarterInfoDTO {
    id: string,
    code: string,
    active: boolean
}

export interface BiologicalActivityDTO {
    activity: string
    category: string[]
    products: string[]
}

export interface ggAddonsDTO {
    starting: Date
    ending?: Date
    addOn: string
    addModule: string
    id?: string;
    customerDataId?: string;
    active?: boolean;
}

export interface FindAllCustomersFilters {
    headquarterId: HeadQuarterDTO | null,
    active: boolean | null,
    order: boolean
    norm: string | null,
    companyName: string | null,
    search: string | null,
    itemsPerPage: number
    page: number
    operatorsGroup: string | null;
}

export enum HeadQuarterDTO {
    SC = 'SC',
    IM = 'IM',
    PU = 'PU',
    BA = 'BA',
    IS = 'IS',
    TV = 'TV',
}

export interface CustomerCreationDTO {
    companyName: string
    legalForm: string
    cuaa: string
    vat: string
    address: string
    countryRegion: string
    province: string
    city: string
    zipCode: string

    latitude: string | null
    longitude: string | null

    rpAddress: string
    rpCountryRegion: string
    rpCity: string
    rpProvince: string
    rpZipCode: string

    addresseeCode: string | null
    accountingCode: string | null
    bankDetails: string | null

    startingDate: Date | null
    entryReason: EntryReason
    entryOdcId: string | null
    takeoverDetails: string | null
    endingDate: Date | null
    exitReason: ExitReason | null
    exitOdcId: string | null
    changeOperatorDetails: string | null
    note: string | null
    norm: Norma
    active: boolean | null
    clientCode: string | null
    codeType: CodeType
    existingCode: string | null
    clientType: ClientType
    operatorsGroup: OperatorsGroup | null
    leaderId: number | null
    headQuarterIds: string[]
    biologicalActivity: BiologicalActivityDTO[]
    sqnpiSubjectType: SqnpiSubjectType | null
    sqnpiAdhesionType: SqnpiAdhesionType[] | null
    sqProductionChain: SqProductionChain[] | null
    zrCertificationType: ZrCertificationType | null
    zrTargetThreshold: number | null
    zrAddingRequirements: ZrAddingRequirements | null
    zrType: ZrType | null
    ggGgn: string | null
    ggStandard: GgStandard | null
    ggEdition: GgEdition | null
    ggApplicationField: GgApplicationField | null
    ggCategory: GgCategory | null
    ggIFACertificationOption: GgIFACertificationOption | null
    ggManipulation: GgManipulation | null
    ggParallelProperty: boolean | null
    ggLabelling: boolean | null
    ggLicenseGnnLabelLogo: boolean | null
    ggPartialTransformation: boolean | null
    ggCOCCertificationOption: string | null
    ggAddOns: ggAddonsDTO[] | null
}

export enum EntryReason {
    PRIMA_NOTIFICA = 'PRIMA_NOTIFICA',
    CAMBIO_ODC_INGRESSO = 'CAMBIO_ODC_INGRESSO',
    SOSTITUZIONE = 'SOSTITUZIONE'
}

export enum ExitReason {
    CAMBIO_ODC_USCITA = 'CAMBIO_ODC_USCITA',
    CAMBIO_OPERATORE = 'CAMBIO_OPERATORE',
    RECESSO = 'RECESSO',
    ESCLUSIONE = 'ESCLUSIONE'
}

export enum CodeType {
    NUOVO_CODICE = 'NUOVO_CODICE',
    CODICE_ESISTENTE = 'CODICE_ESISTENTE',
}

export enum ClientType {
    SINGOLO = 'SINGOLO',
    GRUPPO_DI_OPERATORI = 'GRUPPO_DI_OPERATORI',
}

export enum OperatorsGroup {
    CAPOFILA = 'CAPOFILA',
    MEMBRO = 'MEMBRO'
}

export enum SqnpiSubjectType {
    SINGOLO = 'SINGOLO',
    ASSOCIATO = 'ASSOCIATO',
}

export enum SqnpiAdhesionType {
    TERRENI = 'TERRENI',
    TRASFORMAZIONE_CONFEZIONAMENTO = 'TRASFORMAZIONE_CONFEZIONAMENTO',
    INTERMEDIAZIONE = 'INTERMEDIAZIONE',
    COMMERCIALIZZAZIONE_PRODOTTO_SFUSO = 'COMMERCIALIZZAZIONE_PRODOTTO_SFUSO',
}

export enum SqProductionChain {
    FILIERA_BOVINA = 'FILIERA_BOVINA',
    FILIERA_GRANO_DURO_E_DERIVATI = 'FILIERA_GRANO_DURO_E_DERIVATI',
    FILIERA_AGNELLO_AGNELLONE = 'FILIERA_AGNELLO_AGNELLONE',
    FILIERA_LATTE_CRUDO_VACCINO_E_DERIVATI = 'FILIERA_LATTE_CRUDO_VACCINO_E_DERIVATI',
}

export enum ZrCertificationType {
    RESIDUO_CONTROLLATO = 'RESIDUO_CONTROLLATO',
    RESIDUO_ZERO = 'RESIDUO_ZERO',
}

export enum ZrAddingRequirements {
    PACKAGING_COMPOSTABILE = 'PACKAGING_COMPOSTABILE',
    PACKAGING_PLASTIC_FREE = 'PACKAGING_PLASTIC_FREE',
    NON_UTILIZZA_PRINCIPI_ATTIVI = 'NON_UTILIZZA_PRINCIPI_ATTIVI',
}

export enum ZrType {
    PRODUTTORE_AGRICOLO = 'PRODUTTORE_AGRICOLO',
    IMPRESA_DI_TRASFORMAZIONE_CONDIZIONAMENTO_STOCCAGGIO_COMMERCIALIZZAZIONE_ECC = 'IMPRESA_DI_TRASFORMAZIONE_CONDIZIONAMENTO_STOCCAGGIO_COMMERCIALIZZAZIONE_ECC',
    PRODUTTORE_AGRICOLO_ED_IMPRESA_DI_TRASFORMAIONE_CONDIZIONAMENTO_STOCCAGGIO_COMMERCIALIZZAIZONE_ECC = 'PRODUTTORE_AGRICOLO_ED_IMPRESA_DI_TRASFORMAIONE_CONDIZIONAMENTO_STOCCAGGIO_COMMERCIALIZZAIZONE_ECC',
}

export enum GgStandard {
    IFA = 'IFA',
    CoC = 'CoC',
}

export enum GgEdition {
    SMART = 'SMART',
    GFS = 'GFS',
}

export enum GgApplicationField {
    PIANTE = 'PIANTE',
    AQUACULTURE = 'AQUACULTURE'
}

export enum GgCategory {
    FRUTTA_E_VERDURA = 'FRUTTA_E_VERDURA',
    FIORI_E_PIANTE_ORNAMENTALI = 'FIORI_E_PIANTE_ORNAMENTALI',
    CULTURE_COMBINABILI_COLTIVAZIONI_ALL_APERTO = 'CULTURE_COMBINABILI_COLTIVAZIONI_ALL_APERTO',
    MATERIALE_DI_MOLTIPLICAZIONE_DELLE_PIANTE = 'MATERIALE_DI_MOLTIPLICAZIONE_DELLE_PIANTE',
    TE = 'TE',
    LUPPOLO = 'LUPPOLO'
}

export enum GgIFACertificationOption {
    OPZIONE_1_PRODUTTORE_CON_SITO_SINGOLO = 'OPZIONE_1_PRODUTTORE_CON_SITO_SINGOLO',
    OPZIONE_1_PRODUTTORE_MULTISITO_SENZA_SGQ = 'OPZIONE_1_PRODUTTORE_MULTISITO_SENZA_SGQ',
    OPZIONE_1_PRODUTTORE_MULTISITO_CON_SGQ = 'OPZIONE_1_PRODUTTORE_MULTISITO_CON_SGQ',
    OPZIONE_2_CERTIFICAZIONE_DI_GRUPPO = 'OPZIONE_2_CERTIFICAZIONE_DI_GRUPPO'
}

export enum GgManipulation {
    NESSUNA = 'NESSUNA',
    CAMPO = 'CAMPO',
    MAGAZZINO = 'MAGAZZINO',
    CAMPO_E_MAGAZZINO = 'CAMPO_E_MAGAZZINO'
}

export interface CustomerUpdateDTO {
    companyName?: string
    legalForm?: string
    cuaa?: string
    vat?: string
    address?: string
    countryRegion?: string
    province?: string
    city?: string
    zipCode?: string

    latitude?: string | null
    longitude?: string | null

    rpAddress?: string
    rpCountryRegion?: string
    rpCity?: string
    rpProvince?: string
    rpZipCode?: string

    addresseeCode?: string | null
    accountingCode?: string | null
    bankDetails?: string | null

    startingDate?: Date | null
    entryReason?: EntryReason
    entryOdcId?: string | null
    takeoverDetails?: string | null
    endingDate?: Date | null
    exitReason?: ExitReason | null
    exitOdcId?: string | null
    changeOperatorDetails?: string | null
    note?: string | null
    norm?: Norma
    active?: boolean | null
    leaderId?: number | null
    headQuarterIds?: string[]
    biologicalActivity?: BiologicalActivityDTO[]
    sqnpiSubjectType?: SqnpiSubjectType | null
    sqnpiAdhesionType?: SqnpiAdhesionType[] | null
    sqProductionChain?: SqProductionChain[] | null
    zrCertificationType?: ZrCertificationType | null
    zrTargetThreshold?: number | null
    zrAddingRequirements?: ZrAddingRequirements | null
    zrType?: ZrType | null
    ggGgn?: string | null
    ggStandard?: GgStandard | null
    ggEdition?: GgEdition | null
    ggApplicationField?: GgApplicationField | null
    ggCategory?: GgCategory | null
    ggIFACertificationOption?: GgIFACertificationOption | null
    ggManipulation?: GgManipulation | null
    ggParallelProperty?: boolean | null
    ggLabelling?: boolean | null
    ggLicenseGnnLabelLogo?: boolean | null
    ggPartialTransformation?: boolean | null
    ggCOCCertificationOption?: string | null
    ggAddOns?: ggAddonsDTO[] | null
}

export type Norma = 'NORMA_BIO' | 'PRODUZIONE_INTEGRATA' | 'DETERGENZA' | 'GLOBAL_GAP' | 'QUALITA_SICURA' | 'RESIDUO_ZERO'

export interface CustomerByCodeResponseDTO {
    id: string
    companyName: string
    cuaa: string
    clientCode: string
    countryRegion: string
    endingDate: Date,
    startingDate: Date,
}

export interface FindAllCustomerByCodeResponseDTO {
    data: CustomerByCodeResponseDTO[]
}